<template>
  <div>
    <div v-if="deviceType === config.DEVICE_WECHAT" style="height: 44px;">
      <div v-if="deviceType === config.DEVICE_WECHAT" class="broswer-tip">
        <div>请点击右上角，选择在浏览器内打开</div>
        <div class="broswer-arrow"></div>
      </div>
    </div>
    <div>
      <Header :deviceType="deviceType"></Header>
      <div v-if="loading" class="loading">
        <img
          style="position: absolute;top: 50%; margin-top: -16px; margin-left: -16px;"
          src="../assets/images/loading.gif"
          alt
        >
      </div>
      <div class="main" v-show="!loading">
        <AppOverview :appInfo="appInfo" :isCollapse="isCollapse"></AppOverview>
        <section class="app-content" :class="{'collapsed': isCollapse}" v-if="appInfo.printscreen && appInfo.printscreen.length">
          <section id="screen-slider" v-if="appInfo.printscreen && appInfo.printscreen.length">
            <ul class="swiper-wrapper">
              <li v-for="(item, index) in appInfo.printscreen" :key="index" class="swiper-slide">
                <img :src="item" @click="() => { imgPreview(index) }">
              </li>
            </ul>
          </section>
          <section class="app-brief" @click="renderInfo">
            <p>{{appInfo.brief}}</p>
            <div></div>
          </section>
          <section
            class="relation-slider"
            v-for="(cate, cateIndex) in relationApps.category"
            :key="cate.name"
            v-if="cate.apps && cate.apps.length"
          >
            <h3
              class="group-title"
            >{{(cate.category && cate.category.name) ? (`"${(cate.category && cate.category.name)}"其他热门应用`) : `安装"${appInfo.name}"的用户还喜欢`}}</h3>
            <div class="group-content" :id="`relation-slider${cateIndex}`" style="overflow: auto;">
              <ul class="swiper-wrapper group-list">
                <li v-for="(item, index) in cate.apps" :key="index" class="swiper-slide">
                  <img
                    :src="item.logo"
                    @click="() => {renderOtherApp(item.package, { source_groupid: cateIndex + 1, source_groupname: (cate.category && cate.category.name) || ('安装' + appInfo.name + '的用户还喜欢') });}"
                  >
                  <span>{{item.name}}</span>
                  <img style="position: absolute; width: 30px; height: 30px;" class="animate" src="../assets/images/button-loading.png" alt="">
                  <button
                    class="btn"
                    v-show="!loadingStatusAppArray.includes(item.package)"
                    @click="() => {
                      clickDownload(item, {
                        pkg_name: item.package,
                        app_type: appInfo.soft_type,
                        download_position: downloadPositionDictionary['GROUP'],
                        page_type: config.PAGE_TYPE.HOME,
                        group_id: cateIndex + 1,
                        group_name: (cate.category && cate.category.name) || reusableText[0],
                      })
                    }"
                  >安装</button>
                </li>
              </ul>
            </div>
          </section>
          <section
            class="classics-slider"
            v-for="(cate, cateIndex) in classicsApps.category"
            v-if="cate.apps && cate.apps.length"
            :key="cate.name"
          >
            <h3 class="group-title">{{cate.name}}</h3>
            <div class="group-content" :id="`classics-slider${cateIndex}`" style="overflow: auto;">
              <ul class="swiper-wrapper group-list">
                <li v-for="(item, index) in cate.apps" :key="index" class="swiper-slide">
                  <img
                    :src="item.logo"
                    @click="() => {renderOtherApp(item.package, { source_groupid: cateIndex + 1, source_groupname: cate.name });}"
                  >
                  <span>{{item.name}}</span>
                  <img style="position: absolute; width: 30px; height: 30px;" class="animate" src="../assets/images/button-loading.png" alt="">
                  <button
                    class="btn"
                    v-show="!loadingStatusAppArray.includes(item.package)"
                    @click="() => {
                      clickDownload(item, {
                        pkg_name: item.package,
                        app_type: item.soft_type,
                        download_position: downloadPositionDictionary['GROUP'],
                        page_type: config.PAGE_TYPE.HOME,
                        group_id: cateIndex + 1,
                        group_name: cate.name,
                      })
                    }"
                  >安装</button>
                </li>
              </ul>
            </div>
          </section>
        </section>
        <div v-if="bottomApp.logo && isShowBottomBanner" style="height: 80px;"></div>
        <footer v-if="bottomApp.logo && isShowBottomBanner">
          <div class="close" @click="handleClose"></div>
          <div class="app-icon">
            <img
              :src="bottomApp.logo"
              alt
              @click="() => {renderOtherApp(bottomApp.package, { source_groupid: 1, source_groupname: '吸底' });}"
            >
          </div>
          <div>
            <p class="footer-app-name">{{bottomApp.name}}</p>
            <p class="footer-app-brief">{{bottomApp.recmd_brief}}</p>
          </div>
          <img style="position: absolute; width: 30px; height: 30px;" class="animate" src="../assets/images/button-loading.png" alt="">
          <button
            class="btn btn-primary"
            v-show="!loadingStatusAppArray.includes(bottomApp.package)"
            @click="() => {
              clickDownload(bottomApp, {
                pkg_name: bottomApp.package,
                app_type: bottomApp.soft_type,
                download_position: downloadPositionDictionary['吸底'],
                page_type: config.PAGE_TYPE.HOME,
                group_id: 1,
                group_name: '吸底',
              })
            }"
          >安装</button>
        </footer>
      </div>
    </div>
    <div
      class="img-modal"
      id="img-modal"
      v-show="imgPreviewState"
      @click="() => imgPreviewState = false"
    >
      <ul class="swiper-wrapper">
        <li
          v-for="(item, index) in appInfo.printscreen"
          :key="index"
          style="display: flex; align-items: center; justify-content: center;"
          class="swiper-slide"
        >
          <img :src="item" style="height: 80%;">
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swiper from "swiper";
import { getAllAppInfo, reportLog } from "@/constants/api";
import Config from "@/constants/config";
import "swiper/dist/css/swiper.min.css";
import Header from "@/components/Header";
import AppOverview from "@/components/AppOverview";
import { checkDeviceType, getPageType, downloadFile } from "@/constants/util";

export default {
  name: "app-home",
  props: {
    deviceType: String
  },
  components: { Header, AppOverview },
  data() {
    return {
      config: Config,
      loading: true,
      package: this.$route.query.package || "",
      pageType: getPageType(this),
      isCollapse: false,
      appInfo: {},
      relationApps: {},
      classicsApps: {},
      bottomApp: {},
      downloadPositionDictionary: Config.DOWNLOAD_POSITION_DICTIONARY,
      reusableText: [
        // 警告！不能修改位置, 可尾部新增
        `${
          this.appInfo ? `安装"${this.appInfo.name}"的用户还喜欢` : "猜你喜欢"
        }`
      ],
      showImgModal: false,
      isShowBottomBanner: true,
      imgPreviewState: false,
      myImgModal: '',
      loadingStatusAppArray: [],
      downloadAppLoadingTime: Config.DOWNLOAD_APP_TIME,
    };
  },
  computed: {
    ...mapGetters(["getApp"])
  },
  watch: {
    getApp() {
      this.loading = true;
      this.setData();
    },
    $route(to) {
      const packageName = to.query.package;
      this.package = packageName;
      // location.reload();
    }
  },

  methods: {
    ...mapActions(["setApp"]),
    handleClose() {
      this.isShowBottomBanner = false;
    },
    imgPreview(index) {
      this.imgPreviewState = true;
      this.myImgModal.slideTo(index);
    },
    initScreenSlide() {
      const self = this;
      setTimeout(() => {
        // 图片
        self.myImgModal = new Swiper("#img-modal", {
          preventClicksPropagation : false,
          initialSlide: 0,
          observer:true,
        });

        self.imgSwiper = new Swiper("#screen-slider", {
          slidesPerView: "auto", // n 个 slider
          freeMode: true, // 惯性滑动, 为false 只滑动 一格
          slidesOffsetBefore: 12, // 左边偏移
          slidesOffsetAfter: 12, // 右偏移
          freeModeMomentum: true, // 动量， 为false 立即停止滑动
          freeModeMomentumVelocityRatio: 5, // 数值越大，滑得越快
          spaceBetween: 10 // 间隔
        });

        const sameSwiperGroup = selectorIdArr => {
          selectorIdArr.forEach(selectorId => {
            new Swiper(selectorId, {
              slidesPerView: "auto",
              slidesPerGroup: 3,
              freeMode: false,
              slidesOffsetBefore: 12,
              slidesOffsetAfter: 12,
              freeModeMomentum: true,
              freeModeMomentumVelocityRatio: 5,
              spaceBetween: 18
            });
          });
        };
        const classicSliderStr = "#classics-slider";
        const relationSliderStr = "#relation-slider";
        const relationIdArr = [];
        const classicsIdArr = [];
        this.relationApps.category.map((item, index) => {
          relationIdArr.push(`${relationSliderStr}${index}`);
        });
        this.classicsApps.category.map((item, index) => {
          classicsIdArr.push(`${classicSliderStr}${index}`);
        });
        sameSwiperGroup(relationIdArr.concat(classicsIdArr));
      });
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isCollapse = !!(scrollTop > 30);
    },
    setData() {
      const app = this.getApp;
      this.appInfo = app.app_info;
      this.relationApps = app.relation_apps;
      this.classicsApps = app.classics_apps;
      this.bottomApp =
        (app.bottom_apps.category &&
          app.bottom_apps.category.length > 0 &&
          app.bottom_apps.category[0].apps[0]) ||
        {};
      this.initScreenSlide();
      this.loading = false;
    },
    async init() {
      const app = this.getApp;
      if (JSON.stringify(app) == "{}" || JSON.stringify(app) == "[]") {
        if (this.package !== "") {
          const options = {
            package: this.package
          };
          let { body: data, head } = await getAllAppInfo(options);
          if (head.code === 0) {
            this.isShowBottomBanner = true;
            window.scrollY = 0;
            const appInfo = data.app_info;
            this.reusableText[0] = `安装"${appInfo.name}"的用户还喜欢`;
            this.setApp(data);
            this.loadPackageReport({
              pkg_name: appInfo.package,
              app_type: appInfo.soft_type, // 0-应用；1-游戏
              source_groupid: this.$route.query.source_groupid || "", // 来源group（groupID（点击主按钮时，上报group来源））
              source_groupname: this.$route.query.source_groupname || ""
            });
          } else {
            alert("获取数据失败");
          }
        } else {
          alert("包名为空, 无法获取数据");
        }
      } else {
        this.setData();
      }
    },
    loadPackageReport(reportOptions) {
      const getCustomParams = () => {
        const deviceType = checkDeviceType();
        const ifWeChat = deviceType === Config.DEVICE_WECHAT ? 1 : 2;
        const param = {};
        param.ifWeChat = ifWeChat;
        param.page_type = getPageType(this);
        Object.assign(param, reportOptions);
        return param;
      };
      reportLog(Config.PAGE_START_LOADING_EVENT, getCustomParams, {
        package: reportOptions.pkg_name
      });
    },
    async renderOtherApp(packageName, reportOptions) {
      if (!packageName) return;
      this.$router.push(
        `/app-home/?package=${packageName}&source_groupid=${reportOptions.source_groupid ||
          ""}&source_groupname=${reportOptions.source_groupname || ""}`
      );
      this.loading = true;
      this.package = packageName;
      const options = {
        package: this.package
      };
      let { body: data, head } = await getAllAppInfo(options);
      if (head.code === 0) {
        this.isShowBottomBanner = true;
        this.toScrollTop();
        this.setApp(data);
        const appInfo = data.app_info;
        this.reusableText[0] = `安装"${appInfo.name}"的用户还喜欢`;
        // 上报 加载
        this.loadPackageReport({
          pkg_name: appInfo.package,
          app_type: appInfo.soft_type,
          source_groupid: reportOptions.source_groupid,
          source_groupname: reportOptions.source_groupname
        });
      } else {
        alert("获取数据失败");
      }
    },
    clickDownload(item, reportOptions) {
      let downloadUrl = item.download_url;
      const self = this;
      const ifWeChat = self.deviceType === Config.DEVICE_WECHAT ? 1 : 2;

      if (self.deviceType === Config.DEVICE_WECHAT) {
        self.toScrollTop();
        const div = document.createElement("div");
        div.className = "screen-modal";
        div.onclick = e => {
          const target = e.target;
          document.body.removeChild(target);
        };
        document.body.style.overflowY = "hidden";
        document.body.appendChild(div);
        document.body.style.overflowY = "";
        return;
      }

      // loading status
      self.loadingStatusAppArray.push(item.package);
      setTimeout(() => {
        self.loadingStatusAppArray = self.loadingStatusAppArray.filter(
          loadingStatusItem => loadingStatusItem !== item.package
        );
      }, self.downloadAppLoadingTime);

      // 上报 安装
      const getCustomParams = () => {
        const param = {};
        Object.assign(param, reportOptions);
        param.page_type = getPageType(this);
        param.ifWeChat = ifWeChat;
        param.source_groupid = this.$route.query.source_groupid || "";
        param.source_groupname = this.$route.query.source_groupname || "";
        return param;
      };
      reportLog(Config.DOWNLOAD_CLICK_EVENT, getCustomParams, {
        package: reportOptions.pkg_name
      });
      downloadUrl += "&timestamp=" + new Date().getTime();
      downloadFile(downloadUrl);
    },
    toScrollTop() {
      const time = 800;
      const ms = time / times;
      const times = 27;
      const height = +document.documentElement.scrollTop;
      const fun = () => {
        if (!+document.documentElement.scrollTop) {
          return;
        }
        document.documentElement.scrollTop -= height / times;
        setTimeout(fun, ms);
      };
      fun();
    },
    renderInfo() {
      const packageName = this.package;
      // 加载 上报
      this.loadPackageReport({
        pkg_name: this.package,
        app_type: this.appInfo.soft_type,
        source_groupid: this.$route.query.source_groupid,
        source_groupname: this.$route.query.source_groupname,
        page_type: getPageType(Config.PAGE_TYPE.INFO)
      });
      this.$router.push(
        `/app-info/?package=${packageName}&source_groupid=${this.$route.query
          .source_groupid || ""}&source_groupname=${this.$route.query
          .source_groupname || ""}`
      );
    }
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.init();
  }
};
</script>

<style scoped lang="scss">
$imgPath: "../assets/images/";

h3 {
  font-size: 15px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: bold;
  box-shadow: inset 0px 0.67px 0px rgba(0, 0, 0, 0),
    inset 0px -0.67px 0px rgba(0, 0, 0, 0.1);
}
.close {
  width: 10px;
  height: 10px;
  position: absolute;
  right: 5px;
  top: 5px;
  text-align: center;
  font-size: 12px;
  background-image: url($imgPath+"stop.svg");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  color: #ccc;
}
.loading {
  width: 100%;
  height: 100%;
  text-align: center;
  position: fixed;
  color: #fefefe;
  top: 0;
  z-index: 999999;
  background-color: rgba(1, 1, 1, 0.56789);
}

.group-title {
  height: 40px;
  padding-left: 12px;
  line-height: 40px;
  font-size: 15px;
  color: #666;
}

.group-content {
  height: 170px !important;
  overflow: hidden !important;
}

.group-list {
  li {
    display: flex;
    justify-content: center;
    padding: 18px 0;
    box-sizing: border-box;
    width: 68px !important;
    height: 170px;
    text-align: center;
    position: relative;
  }
  img {
    width: 68px;
    height: 68px;
    border-radius: 12px;
    overflow: hidden;
  }
  span {
    width: 100%;
    position: absolute;
    bottom: 58px;
    left: 0;
    color: #333;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .btn {
    display: block;
    position: absolute;
    bottom: 18px;
    background-color: #fff;
    color: #636363;
  }
}
.btn {
  width: 68px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  border: 0.67px solid #dcdcdc;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  font-size: 13.5px;
  font-weight: bold;
  position: absolute;
  bottom: 18px;
  outline: none;
  &:active {
    background: linear-gradient(180deg, #e5e5e5 0%, #f5f5f5 100%);
    border: .67px solid #cccccc;
  }
}
.btn.btn-primary {
  color: #fff;
  background: linear-gradient(180deg, #a2d35e 0%, #90cb4a 100%);
  border: 0.67px solid #5ba319;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.2);
  text-shadow: 0px -0.67px 0px rgba(111, 164, 43, 0.7);
}

.main {
  position: relative;
  margin-top: 48px;

  .animate {
    -webkit-animation: plays 1s infinite;
    bottom: 18px;
  }
  @-webkit-keyframes plays {
    0%  {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  .app-content {
    padding-top: 129px;

    &.collapsed {
      padding-top: 50px;
    }

    #screen-slider {
      padding: 16px 0;
      overflow: hidden;

      ul {
        li {
          flex-shrink: 0;
          width: 110px;
          border-radius: 2px;
          overflow: hidden;

          img {
            display: block;
            width: 100%;
          }
        }
      }
    }
    .app-brief {
      display: flex;
      height: 70px;
      line-height: 70px;
      background-color: #fff;
      box-shadow: inset 0px 0.67px 0px rgba(0, 0, 0, 0.1),
        inset 0px -0.67px 0px rgba(0, 0, 0, 0.1);
      margin-bottom: 6px;
      overflow: hidden;

      > p {
        margin: 16px 3px 16px 16px;
        flex-grow: 1;
        font-size: 12px;
        color: #999;
        line-height: 19px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      > div {
        flex-grow: 0;
        flex-shrink: 0;
        width: 28px;
        background-image: url($imgPath+"next-page.svg");
        background-size: 14px;
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    .relation-slider,
    .classics-slider,
    #relation-slider,
    #classics-slider {
      height: 210px;
      margin-bottom: 6px;
      background-color: #fff;
      box-shadow: inset 0px 0.67px 0px rgba(0, 0, 0, 0.1),
        inset 0px -0.67px 0px rgba(0, 0, 0, 0.1);
    }
  }

  footer {
    display: flex;
    align-items: center;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    background-color: #fff;
    box-sizing: border-box;
    box-shadow: 0px -0.67px 0px rgba(0, 0, 0, 0.1),
      0px -4px 10px rgba(0, 0, 0, 0.05);
    padding: 16px 12px;
    z-index: 99;

    .animate {
      right: 31px;
      top: 50%;
      margin-top: -15px;
    }

    .app-icon {
      width: 48px;
      height: 48px;
      border-radius: 18px;
      overflow: hidden;
      display: flex;
      flex-shrink: 0;
      justify-content: space-between;
      align-items: center;
      margin-right: 12px;
      float: left;
      border-radius: 6px;
      overflow: hidden;

      img {
        width: 100%;
      }
    }

    p {
      font-size: 12px;
    }

    .btn {
      right: 12px;
      top: 50%;
      margin-top: -15px;
    }

    .footer-app-name {
      font-size: 14px;
      line-height: 16px;
      font-weight: bold;
    }

    .footer-app-brief {
      padding-right: 78px;
      margin-top: 5px;
      line-height: 16px;
      color: rgba(0, 0, 0, 0.4);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
